import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "error"];
import { useQuery, registerQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import { useSelector } from 'react-redux';
import { requestFetchPersonalizationVariants } from '../api/personalization';
import { getIsLandingPage, getIsSitePage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
const PersonalizationVariantsQuery = registerQuery({
  fieldName: 'personalizationVariants',
  args: ['id', 'contentPath'],
  fetcher: requestFetchPersonalizationVariants
});
export const useFetchPersonalizationVariants = ({
  contentId,
  shouldFetch = true
}) => {
  const isLandingPage = useSelector(getIsLandingPage);
  const isSitePage = useSelector(getIsSitePage);
  const contentPath = isLandingPage ? 'landing-pages' : isSitePage ? 'site-pages' : '';
  const _useQuery = useQuery(PersonalizationVariantsQuery, {
      variables: {
        id: contentId,
        contentPath
      },
      skip: !shouldFetch || !contentPath
    }),
    {
      data,
      loading,
      error
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  if (error) {
    Raven.captureMessage('[P13n] - Error fetching personalization variants', {
      extra: {
        error
      }
    });
  }
  return Object.assign({
    data,
    loading,
    error
  }, rest);
};